import { gray5, mainColor, white } from "assets/styleUtils";
import useUser from "hooks/useUser";
import { sendAuthCode } from "pages/CounselingInfo/CounselingInfo";
import { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { post } from "utils/ApiUtil";

export default function CertifyPhone({
  bride_phone,
  code,
  setExistPhoneNum,
  setAuthCode,
  width,
}: {
  bride_phone?: string;
  code: string;
  setExistPhoneNum: (data: boolean) => void;
  setAuthCode: (data?: string) => void;
  width?: string;
}) {
  const [codeNumber, setCodeNumber] = useState("");

  const codeNumberRef = useRef<React.MutableRefObject<any> | null>(null);
  const { user, getUser } = useUser();

  const authCheck = async () => {
    if (codeNumber === code) {
      toast.success("인증되었습니다");

      setAuthCode(undefined);
      setExistPhoneNum(true);
      ////updatesignup으로 핸드폰번호 보내기
      const { success } = await post("/api/user/updatesignup", {
        phone_number: bride_phone,
      });
      if (success) {
        getUser();
      }
    } else {
      toast.error("다시 입력해주세요");
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            width: width,
            marginTop: 8,
          }}
        >
          <input
            maxLength={4}
            type="number"
            onChange={(e) => setCodeNumber(e.target.value)}
            placeholder="인증코드 4자리"
            style={{
              alignContent: "center",
              height: "100%",
            }}
          />
        </div>
        <div
          style={{
            width: "50px",
            height: "40px",
            borderRadius: "3px",
            marginRight: "10px",
            marginTop: "10px",
            textAlign: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={authCheck}
        >
          <div
            style={{
              width: "60px",
              marginLeft: "5px",
              height: "90%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              color: white,
              backgroundColor: mainColor,
            }}
          >
            확인
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          marginLeft: "3px",
          marginTop: "7px",
        }}
      >
        <span
          style={{
            fontWeight: 500,
            color: gray5,
            fontSize: "12px",
          }}
        >
          인증번호가 오지 않았나요?
        </span>
        <div
          style={{ height: 30 }}
          onClick={() =>
            bride_phone &&
            sendAuthCode({
              setCodeCallback: setAuthCode,
              bride_phone,
            })
          }
        >
          <span
            style={{
              fontWeight: 500,
              color: mainColor,
              fontSize: "12px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
          >
            재발송
          </span>
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
    </>
  );
}
